export default "__VITE_ASSET__CR1FUcqv__"